import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 24 * 60 * 60 * 1000,
      refetchOnWindowFocus: false,
      retryOnMount: false,

      retry: (failureCount, error: any) => {
        // Don't retry on Unauthorized
        if (error?.status === 401) return false;
        // Retry once for other errors (e.g. 503)
        return failureCount < 1;
      },
    },
  },
});
